var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"header-title":` `,"header_logo":true,"header_side":true}},[_c('button',{staticClass:"h_search_btn",attrs:{"slot":"headerBtns"},on:{"click":function($event){return _vm.$router.push('/search')}},slot:"headerBtns"})]),_c('div',{staticClass:"dgm_wrap padding_side"},[_c('unsubscribe-result-component')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }